import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Lipstick.svg",
  "use": "Lipstick.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Lipstick.svg\"><path d=\"M39.5,55.9986h-15a1.5,1.5,0,0,1-1.5-1.5V37.4939a1.5,1.5,0,0,1,1.5-1.5H25V25.49a1.5,1.5,0,0,1,1.5-1.5h11a1.5,1.5,0,0,1,1.5,1.5V35.9936h.5a1.5,1.5,0,0,1,1.5,1.5V54.4983A1.5,1.5,0,0,1,39.5,55.9986ZM27,10.7416a5.6748,5.6748,0,0,1,2.316-4.5543.995.995,0,0,1,1.253.0409l5.558,4.7651A2.5018,2.5018,0,0,1,37,12.8919v8.0973a1,1,0,0,1-1,1H28a1,1,0,0,1-1-1Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol